import React, { useEffect } from 'react';
import './employee-list-add-modal.scss';
import { ReactComponent as Close } from 'assets/images/close.svg';
import { ReactComponent as Dot04Icon } from 'assets/icons/dot04.svg';
import TextInput from 'common/text-input/text-input';
import CalendarInput from 'common/calendar-input/calendar-input';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowdown.svg';
import Select from 'react-select';
import Button from 'common/button/button';
import Scrollbars from 'react-custom-scrollbars';
import DateSelector from 'common/date-selector/date-selector';
import { Background } from 'common/CommonModal';
import moment from 'moment';
import { onlyNumberInput, phoneNumberFormatCheck } from 'constants/utils';
import { selectDependentOfPayStatementArr } from 'constants/dataArr';
import { IEmpInPaystatement } from 'types/salary';

export interface IEmpFormInPayStatement {
  name: string;
  phone: string;
  taxType: string;
  dept: string;
  position: string;
  dependent: number;
  gender: string;
}

interface Props {
  isVisible: boolean;
  empData?: IEmpInPaystatement | undefined;
  onClose: Function;
  onSubmit: Function;
}

const EmployeeListAddModal: React.FC<Props> = ({ isVisible, empData, onClose, onSubmit }) => {
  const [birthDate, setBirthDate] = React.useState<Date>(moment().month(0).date(1).toDate());
  const [joinDate, setJoinDate] = React.useState<Date>(moment().toDate());
  const [employeeAddForm, setEmployeeAddForm] = React.useState<IEmpFormInPayStatement>({
    name: '',
    phone: '',
    taxType: 'FOUR-MAJOR-INSURANCES',
    dept: '',
    position: '',
    dependent: 1,
    gender: '1',
  });

  const [errMessages, setErrMessages] = React.useState({
    name: '',
    gender: '',
    phone: '',
  });

  // 입력폼 초기화
  const resetFormState = () => {
    setBirthDate(moment().month(0).date(1).toDate());
    setJoinDate(moment().toDate());
    setEmployeeAddForm({
      name: '',
      phone: '',
      taxType: 'FOUR-MAJOR-INSURANCES',
      dept: '',
      position: '',
      dependent: 1,
      gender: '1',
    });
  };

  // 에러메세지 초기화
  const resetFormErrState = () => {
    setErrMessages({
      name: '',
      gender: '',
      phone: '',
    });
  };

  // 직원등록 모달 닫기
  const onCloseModal = () => {
    onClose(false);
  };

  const handleEmployeeAddForm = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === 'phone') {
      setEmployeeAddForm((values: any) => ({ ...values, [name]: onlyNumberInput(value) }));
    } else {
      setEmployeeAddForm((values: any) => ({ ...values, [name]: value }));
    }
  };

  // 입사일 날짜 피커 변경
  const handleBirthDateSelect = (date: any) => {
    setBirthDate(date);
  };
  // 입사일 날짜 피커 변경
  const handleDOJDateSelect = (date: any) => {
    setJoinDate(date);
  };

  const handleSelectTaxType = (type: string) => {
    setEmployeeAddForm((values: any) => ({ ...values, taxType: type }));
  };

  const handleSelectGenderType = (type: '1' | '0') => {
    setEmployeeAddForm((values: any) => ({ ...values, gender: type }));
  };

  const handleDependentCountSelect = (event: any) => {
    setEmployeeAddForm((values: any) => ({ ...values, dependent: Number(event.value) }));
  };

  const addEmpFormValidCheck = () => {
    let nameFlag = false;
    let phoneFlag = false;
    if (employeeAddForm.name.length !== 0) {
      nameFlag = true;
    }
    if (employeeAddForm.phone.length === 11 && phoneNumberFormatCheck(employeeAddForm.phone)) {
      phoneFlag = true;
    }
    setErrMessages({
      ...errMessages,
      name: nameFlag ? '' : '직원명을 입력해 주세요.',
      phone: phoneFlag ? '' : '올바른 휴대폰번호 11자리를 입력해 주세요.',
    });
    return nameFlag && phoneFlag;
  };

  const handleSubmit = () => {
    if (addEmpFormValidCheck()) {
      const formatData = [
        {
          MEMBER_INDEX: empData ? empData.MEMBER_INDEX : '',
          NAME: employeeAddForm.name,
          SS_NUMBER: moment(birthDate).format('YYMMDD'),
          MOBILE_NO: employeeAddForm.phone.split('-').join(''),
          PAYDAY: '1',
          // WORKING_HOUR: EMPS !== null ? data.WORKING_HOUR : data.WORKING_TIME,
          // WORKING_DAY: data.WORKING_DAY,
          STANDARD_TAX:
            employeeAddForm.taxType === 'FOUR-MAJOR-INSURANCES' ? '0' : employeeAddForm.taxType === '3.3%' ? '1' : '2',
          GENDER: employeeAddForm.gender,
          ENTRY_DATE: moment(joinDate).format('YYYYMMDD'),
          RETIRE_DATE: '',
          DEPARTMENT: employeeAddForm.dept,
          RANK: employeeAddForm.position,
          DEP_FAMILY: employeeAddForm.dependent.toString(),
        },
      ];

      onSubmit(formatData, empData ? '수정' : '등록');
    }
  };

  useEffect(() => {
    if (!isVisible) {
      resetFormState();
      resetFormErrState();
    } else {
      if (empData) {
        setBirthDate(moment(empData.SS_NUMBER).toDate());
        setJoinDate(moment(empData.ENTRY_DATE).toDate());
        setEmployeeAddForm({
          name: empData.NAME,
          phone: empData.MOBILE_NO.split('-').join(''),
          taxType:
            empData.STANDARD_TAX === '4대보험'
              ? 'FOUR-MAJOR-INSURANCES'
              : empData.STANDARD_TAX === '3.3%'
              ? '3.3%'
              : 'NONE',
          gender: empData.GENDER,
          dept: empData.DEPARTMENT,
          position: empData.RANK,
          dependent: Number(empData.DEP_FAMILY) > 0 ? Number(empData.DEP_FAMILY) : 1,
        });
      }
    }
  }, [isVisible, empData]);

  const colourStyles = {
    control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: 'none',
      border: 'none',
      width: '100%',
      height: '56px',
    }),
    multiValueRemove: (base: any) => ({ ...base, display: 'none' }),
  };

  const renderScrollbar = (props: any) => {
    return (
      <div style={{ height: 100 }}>
        <Scrollbars>{props.children}</Scrollbars>
      </div>
    );
  };

  if (!isVisible) return null;
  return (
    <div className="employee-list-add-modal">
      <Background onClick={onCloseModal} />
      <div className="employee-add-modal">
        <div className="modal-actions">
          <div className="modal-action__close" onClick={onCloseModal}>
            <Close />
          </div>
        </div>
        <div className="employee-add-modal__head">급여명세서 직원 등록</div>
        <div className="employee-add-modal__employee-info">
          <div className="employee-add-modal__employee-info__head">
            직원정보 <span className="employee-add-modal__span">(필수)</span>
          </div>
          <div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">직원명</div>
              </div>
              <div className="employee-add-modal__col2">
                <TextInput
                  inputData={handleEmployeeAddForm}
                  value={employeeAddForm.name}
                  placeholder="ex) 홍길동"
                  inputName="name"
                  maxLength={10}
                  errorMessage={errMessages.name}
                />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">생년월일</div>
              </div>
              <div className="employee-add-modal__col2">
                <DateSelector onChange={handleBirthDateSelect} value={birthDate} height={56} />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">성별</div>
              </div>
              <div className="employee-add-modal__col2">
                <div className="employee-add-modal__tax-type">
                  <div
                    className={
                      employeeAddForm.gender === '1'
                        ? 'employee-add-modal__tax-type__select-left employee-add-modal__tax-type__selected'
                        : 'employee-add-modal__tax-type__select-left'
                    }
                    onClick={() => handleSelectGenderType('1')}>
                    남자
                  </div>
                  <div
                    className={
                      employeeAddForm.gender === '0'
                        ? 'employee-add-modal__tax-type__select-right employee-add-modal__tax-type__selected'
                        : 'employee-add-modal__tax-type__select-right'
                    }
                    onClick={() => handleSelectGenderType('0')}>
                    여자
                  </div>
                </div>
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">입사일</div>
              </div>
              <div className="employee-add-modal__col2">
                <DateSelector onChange={handleDOJDateSelect} value={joinDate} height={56} />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">휴대폰번호</div>
              </div>
              <div className="employee-add-modal__col2">
                <TextInput
                  inputData={handleEmployeeAddForm}
                  value={employeeAddForm.phone}
                  placeholder="(-)을 제외한 11자리"
                  inputName="phone"
                  maxLength={11}
                  errorMessage={errMessages.phone}
                />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">세금유형</div>
              </div>
              <div className="employee-add-modal__col2">
                <div className="employee-add-modal__tax-type">
                  <div
                    className={
                      employeeAddForm.taxType === 'FOUR-MAJOR-INSURANCES'
                        ? 'employee-add-modal__tax-type__select-left employee-add-modal__tax-type__selected'
                        : 'employee-add-modal__tax-type__select-left'
                    }
                    onClick={() => handleSelectTaxType('FOUR-MAJOR-INSURANCES')}>
                    4대보험
                  </div>
                  <div
                    className={
                      employeeAddForm.taxType === '3.3%'
                        ? 'employee-add-modal__tax-type__select-middle employee-add-modal__tax-type__selected'
                        : 'employee-add-modal__tax-type__select-middle'
                    }
                    onClick={() => handleSelectTaxType('3.3%')}>
                    3.3%
                  </div>
                  <div
                    className={
                      employeeAddForm.taxType === 'NONE'
                        ? 'employee-add-modal__tax-type__select-right employee-add-modal__tax-type__selected'
                        : 'employee-add-modal__tax-type__select-right'
                    }
                    onClick={() => handleSelectTaxType('NONE')}>
                    없음
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="employee-add-modal__employee-info">
          <div className="employee-add-modal__employee-info__head">
            추가정보 <span className="employee-add-modal__span">(선택)</span>
          </div>
          <div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">부서</div>
              </div>
              <div className="employee-add-modal__col2">
                <TextInput
                  inputData={handleEmployeeAddForm}
                  placeholder="부서를 입력해 주세요 (최대 12자)"
                  value={employeeAddForm.dept}
                  inputName="dept"
                  maxLength={12}
                />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">직급</div>
              </div>
              <div className="employee-add-modal__col2">
                <TextInput
                  inputData={handleEmployeeAddForm}
                  placeholder="부서를 입력해 주세요 (최대 12자)"
                  value={employeeAddForm.position}
                  inputName="position"
                  maxLength={12}
                />
              </div>
            </div>
            <div className="employee-add-modal__row">
              <div className="employee-add-modal__col1">
                <Dot04Icon />
                <div className="employee-add-modal__col1__text">부양가족수</div>
              </div>
              <div className="employee-add-modal__col2">
                <Select
                  className="employee-add-modal__tax-type__dependent-select"
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => (
                      <div style={{ paddingRight: '15px' }}>
                        <ArrowDownIcon />
                      </div>
                    ),
                    MenuList: renderScrollbar,
                  }}
                  isSearchable={false}
                  defaultValue={selectDependentOfPayStatementArr[0]}
                  styles={colourStyles}
                  options={selectDependentOfPayStatementArr}
                  onChange={handleDependentCountSelect}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="employee-add-modal__buttons">
          <div className="employee-add-modal__buttons__cancel">
            <Button label="취소" type="type13" action={onCloseModal} />
          </div>
          <div className="employee-add-modal__buttons__submit">
            <Button label={empData ? '수정' : '등록'} type="type2" action={handleSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListAddModal;
